// extracted by mini-css-extract-plugin
export var active = "_db-2";
export var recordingDot = "_db-1";
export var recordingIndicator = "_db-0";